module.exports = __webpack_public_path__ + "img/pages-index-code.1b0d592a.png";